import React, {useContext} from 'react';
import classnames from 'classnames';
import {Empty} from 'acud';
import {Link} from 'react-router-dom';
import type {EmptyProps} from 'acud/lib/empty';

import {ConfigContext} from '../../common/ConfigProvider';
import {useLocale} from '../../locale';
import {ACUD_PRO_PREFIX} from '../../_common/constants';

import NO_AUTH_IMAGE from './image/NO_AUTH.svg';
import NO_DATA from './image/NO_DATA.svg';
import NO_PAGE from './image/NO_PAGE.svg';
import SERVER_ERROR from './image/SERVER_ERROR.svg';

import './index.less';

export interface EmptyStatusProps extends EmptyProps {
    prefixCls?: string;
    status?: 'NO_DATA' | 'NO_AUTH' | 'NO_PAGE' |'SERVER_ERROR';
}

const EmptyStatus = (props: EmptyStatusProps) => {
    const {prefixCls: customizePrefixCls, status, className, ...emptyProps} = props;

    const {prefixCls: defaultPrefixCls} = useContext(ConfigContext);

    const prefixCls = customizePrefixCls || defaultPrefixCls || ACUD_PRO_PREFIX;

    const [locale] = useLocale('EmptyStatus');

    const STATUS_CONFIG = {
        'NO_AUTH': {
            image: NO_AUTH_IMAGE,
            description: locale?.noAccessPermissions,
            children: locale?.connectAdministrator
        },
        'NO_DATA': {
            image: NO_DATA,
            description: locale?.noResult,
            children: locale?.replaceKeywords
        },
        'NO_PAGE': {
            image: NO_PAGE,
            description: locale?.pageNotFound,
            children: <>
                {locale?.pageDoesNotExist}{locale?.please}
                <a onClick={() => window.location.reload()}>
                    {locale?.refreshPage}
                </a>  </>
        },
        'SERVER_ERROR': {
            image: SERVER_ERROR,
            description: locale?.serverError,
            children:
    <>
        {locale?.serverErrorNoResponse}{locale?.againLater} {locale?.or}
        <Link to='/'>{locale?.returnHome}</Link>
        {locale?.problemStillExists}
    </>
        }
    };

    const statusEmptyProps = {
        ...(status ? STATUS_CONFIG[status] : {}),
        className: classnames(`${prefixCls}-empty-status`, className),
        ...emptyProps
    };
    return <Empty {...statusEmptyProps} />;
};

export default EmptyStatus;